var exports = {
  "jk": "xe533113f--55213a--jk",
};

module.exports = exports;
